import React from 'react';
import { Button } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ANTD_GRAY } from '../../../constants';

// svgs
import { ReactComponent as IconDragIndicator } from '../../../../../../images/icon-drag-indicator.svg';

type Props = {
    setSidePanelWidth: (width: number) => void;
    initialSize: number;
    isSidebarOnLeft?: boolean;
};

const ResizerBar = styled.div`
    min-height: 100%;
    position: relative;
    border-left: 1px solid ${ANTD_GRAY[4]};
`;
export const ProfileSidebarResizer = ({ setSidePanelWidth, initialSize, isSidebarOnLeft }: Props) => {
    const { t } = useTranslation();
    let dragState: { initialX: number; initialSize: number } | undefined;

    const dragContinue = (event: MouseEvent) => {
        if (!dragState) {
            return;
        }

        let xDifference = event.clientX - (dragState.initialX || 0);
        if (isSidebarOnLeft) {
            xDifference = (dragState.initialX || 0) - event.clientX;
        }
        setSidePanelWidth(dragState.initialSize - xDifference);
    };

    const stopDragging = () => {
        window.removeEventListener('mousemove', dragContinue, false);
        window.removeEventListener('mouseup', stopDragging, false);
    };

    const onDrag = (event: React.MouseEvent) => {
        const { clientX } = event;
        dragState = { initialX: clientX, initialSize };

        window.addEventListener('mousemove', dragContinue, false);
        window.addEventListener('mouseup', stopDragging, false);
        event.preventDefault();
    };

    return (
        <ResizerBar>
            <Button
                onMouseDown={(event) => {
                    onDrag(event);
                }}
                title={t('Drag to resize sidebar')}
                className="f-collapse-btn f-hidden-lg"
                aria-label={t('Drag to resize sidebar')}
            >
                <IconDragIndicator />
            </Button>
        </ResizerBar>
    );
};
